import axios from "../common/AuthInterceptor";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL + "/admin/client-networks/";

const getClientNetwork = (clientId) => {
    return axios.get(API_URL + clientId, { headers: authHeader() });
};

const saveClientNetwork = (clientId, networkData) => {
    return axios.post(API_URL + clientId, networkData, { headers: authHeader() });
};

const deleteClientNetwork = (clientId) => {
    return axios.delete(API_URL + clientId, { headers: authHeader() });
};

const clientNetworkService = {
    getClientNetwork,
    saveClientNetwork,
    deleteClientNetwork
};

export default clientNetworkService;
